"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogSeverity = void 0;
var LogSeverity;
(function (LogSeverity) {
    LogSeverity["Debug"] = "Debug";
    LogSeverity["Info"] = "Info";
    LogSeverity["Error"] = "Error";
    LogSeverity["Warn"] = "Warn";
    LogSeverity["Undefined"] = "Undefined";
})(LogSeverity || (exports.LogSeverity = LogSeverity = {}));
//# sourceMappingURL=log-severity.type.js.map